// extracted by mini-css-extract-plugin
export default {"emptyTreatmentsList":"style--emptyTreatmentsList--e998fc","button":"style--button--e17ba3"};